import { render, staticRenderFns } from "./BlockChainComponent.vue?vue&type=template&id=360a24ac&scoped=true"
import script from "./BlockChainComponent.vue?vue&type=script&lang=js"
export * from "./BlockChainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a24ac",
  null
  
)

export default component.exports